import React from 'react'
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

const MAJOR_VERSION = parseInt(React.version.split('.')[0], 10);

const ReactDOMCompat = {
  // 统一的渲染方法
  render: (element: React.ReactNode, container: Element | DocumentFragment) => {
    if (MAJOR_VERSION >= 18) {
      const root = createRoot(container);
      (container as any)._root = root;
      root.render(element);
      return root;
    }
    return ReactDOM.render(element, container);
  },

  // 统一的卸载方法
  unmount: (container: Element | DocumentFragment) => {
    if (MAJOR_VERSION >= 18) {
      const root = (container as any)._root;
      if (root) {
        root.unmount();
        return true;
      }
      return false;
    }
    return ReactDOM.unmountComponentAtNode(container as Element);
  }
};

export default ReactDOMCompat;